import React from 'react';
import Link from 'next/link';

import { withoutBaseUrl } from 'src/services/route-utils';

type Props = {
    items: { url: string; label: string }[];
    includeRootPath?: boolean;
    variant?: 'normal' | 'white';
} & React.DetailedHTMLProps<React.OlHTMLAttributes<HTMLOListElement>, HTMLOListElement>;

export default function Breadcrumb({ items, includeRootPath = true, variant = 'normal', ...rest }: Props) {
    const renderedItems = [...(includeRootPath ? [{ url: '/', label: 'Acasă' }] : []), ...items];

    const defaultClassName = 'text-xs md:text-base';

    return (
        <ul {...rest} className={rest.className ? `${rest.className} ${defaultClassName}` : defaultClassName}>
            {renderedItems.map((item, index, array) => {
                const isLastItem = array.length === index + 1;

                return (
                    <li
                        key={`${item.label}_${index}`}
                        className="inline after:px-2 after:content-['›'] last:after:content-none md:after:px-4">
                        {isLastItem ? (
                            <span className={`${variant === 'normal' ? 'text-medium-green/70' : 'text-white/70'}`}>
                                {item.label}
                            </span>
                        ) : (
                            <Link
                                className={`${variant === 'normal' ? 'text-primary' : 'text-white'} hover:underline}`}
                                href={withoutBaseUrl(item.url)}>
                                {item.label}
                            </Link>
                        )}
                    </li>
                );
            })}
        </ul>
    );
}
